import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  className?: string;
  showArrow?: boolean;
}
export function CTAButton({
  text,
  href = 'https://payments.vantapro.shop/cart/44978652708966:1',
  onClick,
  className = '',
  showArrow = false
}: CTAButtonProps) {
  return <motion.a href={href} onClick={onClick} animate={{
    scale: [1, 1.03, 1]
  }} transition={{
    repeat: Infinity,
    duration: 2,
    ease: 'easeInOut'
  }} className={`
        relative inline-flex items-center justify-center w-full sm:w-auto
        px-8 py-5 text-xl md:text-2xl font-black text-black uppercase tracking-wide
        bg-gradient-to-b from-yellow-300 to-orange-500
        rounded-lg shadow-[0_10px_20px_rgba(249,115,22,0.4)]
        border-b-4 border-orange-700
        hover:from-yellow-200 hover:to-orange-400 hover:translate-y-[2px] hover:border-b-2 hover:shadow-[0_5px_10px_rgba(249,115,22,0.4)]
        transition-all duration-150 text-center
        ${className}
      `} data-id="element-39">
      <span className="drop-shadow-sm flex items-center gap-2" data-id="element-40">
        {text}
        {showArrow && <ArrowRight className="w-6 h-6 md:w-8 md:h-8" strokeWidth={3} data-id="element-41" />}
      </span>
    </motion.a>;
}